module.exports = __webpack_public_path__ + "static/HelveticaNeueLTW1G-Roman-ff4f97838c66a485f08b437ba85c90d0.woff";